import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'maintenance-form',
  templateUrl: './maintenance-form.component.html',
  styleUrls: ['./maintenance-form.component.css']
})
export class MaintenanceFormComponent implements OnInit {
  title="Add Maintainance Office";
  data : any = {};
  formInvalid : boolean = false;
  o : any = {};
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$"; 

  Office_id : number;
  mode : string;

  
  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) 
  { 

  }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.Office_id = params['Office_id'];  
      this.mode =  params['mode'];   
        
        if(this.Office_id > 0){
          this.GetMOfficeById(this.Office_id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Maintainance office ";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Maintainance office ";
    }  
  }

  SaveMOffice(MOffice: NgForm){ 
    
    if(MOffice.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.UserService.PostMOffice(MOffice.value);    
            this.data.subscribe(
            (response) => {
              MOffice.reset();
              MOffice.resetForm();
              MOffice.form.markAsPristine();
              MOffice.form.markAsUntouched();        
              swal('Success!', 'MOffice Added Successfully .', 'success');
              this.router.navigate(['/home/moffice']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetMOfficeById(Office_id){
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.UserService.GetMOfficeById(Office_id);
        this.data.subscribe(
          (response: any) => {
            this.o = response;        
                          
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
  }
  UpdateMOffice(MOffice: NgForm) {  
    this.data = this.UserService.UpdateMOffice(MOffice.value,this.Office_id);
   this.data.subscribe(
     (response) => {
      MOffice.reset();
      MOffice.resetForm();
      MOffice.form.markAsPristine();
      MOffice.form.markAsUntouched();           
                   
       swal('Success!', 'Office updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/moffice/']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401|| error.status == 500) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.o.Office_code='';
this.o.Office_name='';
this.o.Office_H_name='';
this.o.Office_email='';
this.o.Office_Mobile='';
}
}





// WEBPACK FOOTER //
// ./src/app/masters/Maintenance-office/maintenance-form/maintenance-form.component.ts